import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Card from '@mui/material/Card'
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Alert from '@mui/material/Alert';
import { DataGrid } from '@mui/x-data-grid';

import { cancelJob, fetchPendingJobs } from './action';
import { selectPendingJobs, selectUpdateJobError } from './selector';
import { selectUser } from '../Auth/selector';

const PendingJobList = () => {
  const dispatch = useDispatch();
  const authenticatedUser = useSelector(selectUser);
  const pendingJobs = useSelector(selectPendingJobs);
  const updateJobError = useSelector(selectUpdateJobError);

  const [selectedJob, setSelectedJob] = useState(null);

  useEffect(() => {
    dispatch(fetchPendingJobs(authenticatedUser));
  }, [dispatch, authenticatedUser]);

  const petTypes = [
    { label: 'Cat', value: 'cat' },
    { label: 'Dog', value: 'dog' },
  ];

  const onCancel = (row) => {
    setSelectedJob(row);
  };

  const handleCloseDialog = () => {
    setSelectedJob(null);
  };

  const handleCancelJob = () => {
    dispatch(cancelJob(selectedJob));
    setSelectedJob(null);
  };

  const columns = [
    { field: '_id', sortable: false, headerName: 'Job ID', width: 220 },
    {
      field: 'createdAt',
      headerName: 'Created on',
      width: 150,
      valueGetter: (params) => {
        const date = new Date(params.value);
        return date.toLocaleDateString('en-US');
      }
    },
    {
      field: 'petName',
      headerName: 'Pet Name',
      width: 150,
      valueGetter: (params) => params.row.jobDetails.petName,
    },
    {
      field: 'petType',
      headerName: 'Pet Type',
      width: 150,
      valueGetter: (params) => {
        const { petType } = params.row.jobDetails;
        return petTypes.find(pet => pet.value === petType)?.label;
      },
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 150,
      isableClickEventBubbling: true,
      sortable: false,
      renderCell: (params) => (
        <Button
          variant="text"
          onClick={() => onCancel(params.row)}
        >
          Cancel
        </Button>
      ),
    },
  ];

  return (
    <Container component="main" maxWidth="md" sx={{ pt: 6 }}>
      <Card sx={{ padding: "2rem" }}>
      <Dialog
        maxWidth="xs"
        open={selectedJob !== null}
      >
        <DialogTitle sx={{ pb: 3.5 }}>Confirmation</DialogTitle>
        <DialogContent>
          Are you sure you want to cancel this job?
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button autoFocus onClick={handleCloseDialog}>No</Button>
          <Button onClick={handleCancelJob}>Yes</Button>
        </DialogActions>
      </Dialog>
      <Typography variant="h5" component="h1">
        Total Pending Jobs: {pendingJobs.length}
      </Typography>
      {updateJobError && (
        <Alert severity="error" sx={{ mt: 1 }}>{updateJobError}</Alert>
      )}
      <div
        style={{
          height: 80 * pendingJobs.length + 200,
          width: '100%',
          marginTop: 20,
        }}
      >
        <DataGrid
          rows={pendingJobs}
          columns={columns}
          getRowId={row => row._id}
          pageSize={10}
          rowsPerPageOptions={[10]}
        />
      </div>
      </Card>
    </Container>
  );
};

export default PendingJobList;
